import React, { useEffect, useState } from 'react';
import CreateAccount from './create-account ';
import SMSCode from './sms-code';
import Success from './success';

const UserAccount = () => {
  const [step, setStep] = useState(1);
  const [dataFromChild, setDataFromChild] = useState('');

   // تابعی که به فرزند پاس داده می‌شود
   const handleChildData = (data) => {
    setDataFromChild(data);
  };

  // const [formData, setFormData] = useState({
  //   mobileNumber: '',
  //   smsCode: '',
  //   password: '',
  //   rePassword: '',
  // });

  // Go to next step
  const nextStep = () => {
    setStep(step + 1);
  };

  // Go back to prev step
  const prevStep = () => {
    setStep(step - 1);
  };

  // Restart Over
  const restartOver = () => {
    setStep(1);
  };

  // // Handle fields change
  // const handleChange = (input) => (e) => {
  //   setFormData({ ...formData, [input]: e.target.value });
  // };

  // const { name, mobileNumber, smsCode, password, confirmPassword } = formData;
  // const values = { name, mobileNumber, smsCode, password, confirmPassword };

  switch (step) {
    case 1:
      return (
        <CreateAccount
          nextStep={nextStep}
          onSendData={handleChildData}
          // handleChanges={handleChange}
          // values={values}
        />
      );
    case 2:
      return (
        <SMSCode
          nextStep={nextStep}
          prevStep={prevStep}
          // handleChange={handleChange}
          values={dataFromChild}
        />
      );
      // case 3:
      //   return (
      //     <Success
      //       restartOver={restartOver}
      //       // values={values}
      //     />
      //   );
    default:
      return <div>Invalid step</div>;
  }
};

export default UserAccount;